import axios from './axios'
import config from '../config'

export default {
    listDictsByType(type) {
        return axios({
            url: config.backendUrl + '/dicts',
            method: 'GET',
            params: {
                type,
                page: 0,
                size: 10000
            }
        })
    },
    getDictTree(type) {
        return axios({
            url: config.backendUrl + '/dicts/tree',
            method: 'GET',
            params: {
                type
            }
        })
    },
    listAllDictTypes() {
        return axios({
            url: config.backendUrl + '/dicts/types',
            method: 'GET',
        })
    }
}
